// extracted by mini-css-extract-plugin
module.exports = {"remindersContainer":"Reminders_remindersContainer__2HN5m"};